// removed by extract-text-webpack-plugin
module.exports = {"container":"_39Ny5","clickable":"_2X0fj","select":"_2A_YX"};


//////////////////
// WEBPACK FOOTER
// ./app/components/menu-button/menu-button.scss
// module id = 1496
// module chunks = 0